import React, { useState, useEffect, useRef } from 'react';
import '../component.scss';
import SearchField from './SearchField';
import SearchDropdownCountryList from './SearchDropdownCountryList';

const SearchCountryWidget = ({
  value,
  dictionary = {},
  items,
  label,
  title = '',
  width = 220,
  placeholder = true,
  buttonDone = true,
  buttonReset = false,
  onChoose,
  hasFilter = false,
  cssClass = '',
  depart = 1,
  currency = 0,
  isChanged = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isTop, setIsTop] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [wasChanged, setWasChanged] = useState(isChanged);
  const [countryPriceList, setCountryPriceList] = useState([]);

  const dropdownRef = useRef(null);

  const setValue = (value) => {
    setIsOpen(false);
    onChoose(value);
    setSearchTerm('');
    setWasChanged(!!value);
  };

  const reset = () => {
    setValue([]);
    setIsOpen(false);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  const handleTop = () => {
    setIsTop(!isTop);
  };

  const getPrice = async (depart) => {
    if (!depart) {
      return [];
    }
    const url = `https://www.geograftour.com/tourvisor/min-price/?city=${depart}&currency=${currency}&rows=70`;
    const result = await fetch(url).then((r) => r.json());

    if (result.length) {
      setCountryPriceList(result);
    }
  };

  const applyPrices = (items) => {
    return items.map((item) => {
      const priceData = countryPriceList.find((price) => price.id === item.id);
      if (priceData) {
        return {
          ...item,
          price: priceData.minprice,
          tempair: priceData.tempair,
          visa: priceData.visa,
          currency: priceData.currency,
        };
      }
      return item;
    });
  };

  const getFilteredOptions = () => {
    let options = applyPrices(items);
    if (isTop) {
      options = options.filter((country) => country.rank === 0);
    }
    if (searchTerm) {
      options = options.filter((option) =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return options;
  };

  const filteredOptions = getFilteredOptions();

  useEffect(() => {
    getPrice(depart);
  }, [depart, currency]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className={`search-widget ${cssClass}`}>
      {!isOpen ? (
        <>
          <div
            onClick={() => setIsOpen(!isOpen)}
            className={`search-field ${wasChanged}`}
          >
            <SearchField
              cssClass={cssClass}
              placeholder={placeholder}
              label={label}
              title={title}
              value={value}
              dictionary={dictionary}
            />
          </div>
        </>
      ) : (
        <>
          <SearchField
            cssClass={cssClass}
            placeholder={placeholder}
            label={label}
            title={title}
            value={value}
            dictionary={dictionary}
          />
          <div className="popup-list" style={{ width: width }}>
            <div className="popup-filters">
              {hasFilter && (
                <input
                  type="text"
                  placeholder={label}
                  autoFocus
                  className="filterinput"
                  value={searchTerm}
                  onChange={handleInputChange}
                />
              )}
              {buttonDone && (
                <button className="btn-ok" onClick={() => setIsOpen(false)}>
                  Готово
                </button>
              )}
              {buttonReset && (
                <button className="btn-reset" onClick={reset}>
                  Сбросить
                </button>
              )}
              <div className="btn-container">
                <label className="switch btn-country-switch">
                  <input
                    value="0"
                    id="country_type"
                    name="country_type"
                    type="checkbox"
                    checked={isTop}
                    onChange={handleTop}
                  />
                  <label
                    className="btn-country-switch-inner"
                    data-off="Все"
                    data-on="Топ"
                    htmlFor="country_type"
                    onClick={handleTop}
                  />
                </label>
              </div>
            </div>
            {filteredOptions ? (
              <SearchDropdownCountryList
                items={filteredOptions}
                value={value}
                onChoose={setValue}
              />
            ) : null}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchCountryWidget;
